import { useParams } from "react-router-dom";
import { UsersProvider } from "../context";
import UsersContent from "./UsersContent";
import { UsersAlert } from "./UsersAlert";

const UsersDirectory = () => {
  const { userId } = useParams();

  return userId ? (
    <UsersProvider userId={userId}>
      <UsersContent />
    </UsersProvider>
  ) : (
    <UsersAlert title="table.noData" message="users.noUserId" />
  );
};

export default UsersDirectory;
